const categoryDisplayOptions = [
  { value: '1', label: 'Prenatal' },
    { value: '2', label: 'Delivery' },
]

export default categoryDisplayOptions
